
import { CheckIcon } from '@vue-hero-icons/solid';

export default {
  components: { CheckIcon },
  props: {
    url: {
      type: String,
      default: undefined,
    },
  },
};
